/**
 * The service for everything search related
 */
import Fuse from 'fuse.js'

const MINIMUM_END_PART_LENGTH = 200

export default {
  fuzzySearch (haystack, needle) {
    const options = {
      caseSensitive: true,
      shouldSort: true,
      includeScore: true,
      threshold: 0,
      location: 0,
      tokenize: true,
      distance: 20,
      maxPatternLength: 32,
      minMatchCharLength: 3
    }
    return new Promise(resolve => {
      const result = new Fuse(haystack, options).search(needle)
      resolve(result)
    })
  },
  getParts (text = '') {
    const parts = text.match(/.{1,255}/g)
    return parts
  },
  getEndPart (text = '') {
    const parts = this.getParts(text)
    const endPart = parts[parts.length - 1]
    // check if parts array allows indices bigger than 2
    // and if endPart length is smaller than MINIMUM_END_PART_LENGTH (200)
    if (parts.length > 2 && endPart.length < MINIMUM_END_PART_LENGTH) {
      return parts[parts.length - 2]
    }
    return endPart
  },
  getStartPart (text = '') {
    const parts = this.getParts(text)
    if (!parts || !parts.length) {
      throw new Error('Not able to get first part of text ' + text)
    }
    return parts[0]
  }
}



// WEBPACK FOOTER //
// ./src/service/searchService.js